import { ShieldCheck } from 'lucide-react';
import { useState, type FormEvent } from 'react';
import { Redirect } from 'wouter';
import { PhoneField } from '../components/ui/PhoneField';
import { apiErrorMessage } from '../lib/ToastContext';
import { useAuth } from '../lib/AuthContext';

export function LoginPage() {
  const { user, requestOtp, verifyOtp } = useAuth();
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [sent, setSent] = useState(false);
  const [debugOtp, setDebugOtp] = useState<string>();
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  if (user) return <Redirect to="/" replace />;

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      if (!sent) {
        const result = await requestOtp(phone);
        setDebugOtp(result.debugOtp);
        setSent(true);
      } else {
        await verifyOtp(phone, otp);
      }
    } catch (err) {
      setError(apiErrorMessage(err, 'Could not sign in'));
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="grid min-h-dvh place-items-center p-4">
      <section className="card w-full max-w-md p-6 sm:p-8">
        <div className="mb-7">
          <span className="badge mb-3">CY Smart Solutions</span>
          <h1 className="text-3xl font-bold">Welcome back</h1>
          <p className="mt-2 text-muted">Sign in with your mobile number.</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <label className="label">
            Mobile number
            <PhoneField className="mt-1" required disabled={sent} value={phone} onChange={setPhone} />
          </label>
          {sent && (
            <label className="label">
              6-digit OTP
              <input className="field mt-1 text-center text-lg tracking-[0.5em]" inputMode="numeric" autoComplete="one-time-code" maxLength={6} required value={otp} onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))} />
            </label>
          )}
          {debugOtp && (
            <p className="flex items-center gap-2 rounded-xl bg-amber-50 p-3 text-sm text-amber-800">
              <ShieldCheck size={16} className="shrink-0" /> Development OTP: <strong>{debugOtp}</strong>
            </p>
          )}
          {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
          <button className="btn-primary w-full" disabled={busy}>
            {busy ? 'Please wait…' : sent ? 'Verify & sign in' : 'Send OTP'}
          </button>
          {sent && <button type="button" className="btn-ghost w-full" onClick={() => { setSent(false); setOtp(''); setDebugOtp(undefined); setError(''); }}>Use a different number</button>}
        </form>
      </section>
    </main>
  );
}
